import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { AListItem } from '../AListItem/AListItem';
import styles from './m-list.module.scss';
export const MList = ({ colorOverride, items, textSizeOverride })=>/*#__PURE__*/ _jsx("ul", {
        className: styles.list,
        "data-testid": "list",
        children: items?.map((item)=>/*#__PURE__*/ _createElement(AListItem, {
                ...item,
                colorOverride: colorOverride,
                key: item._uid,
                textSizeOverride: textSizeOverride
            }))
    });

//# sourceMappingURL=MList.js.map